import React from "react";
import cx from "classnames";

export default ({ name, className, errors = [], ...props }) => {
    return (
        <>
            <div className="mt-1">
                <input
                    type="date"
                    name={name}
                    className={cx(
                        "form-input",
                        {
                            "form-error": errors.length,
                        },
                        className
                    )}
                    {...props}
                />
            </div>
            {errors && <p className="form-validation-error">{errors}</p>}
        </>
    );
};
